var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1995 8.54354L8.13025 9.88054C6.47338 8.90707 5.09272 7.5264 4.11925 5.86954L5.45625 4.80029C5.61298 4.67487 5.72374 4.50106 5.77124 4.30603C5.81873 4.11099 5.80027 3.90572 5.71875 3.72229L4.49988 0.977412C4.41246 0.780716 4.25804 0.621457 4.06413 0.528027C3.87022 0.434598 3.64943 0.413072 3.44112 0.467287L1.12062 1.06841C0.904184 1.12516 0.71603 1.25923 0.591726 1.44529C0.467422 1.63134 0.41558 1.85648 0.445999 2.07816C0.85313 4.97768 2.19318 7.66584 4.26357 9.73622C6.33395 11.8066 9.0221 13.1467 11.9216 13.5538C12.1432 13.5844 12.3683 13.5326 12.5543 13.4082C12.7402 13.2839 12.8741 13.0956 12.9305 12.8792L13.5325 10.5595C13.5867 10.3512 13.5652 10.1304 13.4718 9.93653C13.3783 9.74262 13.2191 9.5882 13.0224 9.50079L10.2775 8.28191C10.0941 8.2006 9.88898 8.18216 9.69403 8.22948C9.49907 8.27679 9.32522 8.3872 9.1995 8.54354V8.54354Z",
    stroke: "#9D9DAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b613742a3b41d2a558c7d199ca8346e0.svg";
export { ForwardRef as ReactComponent };